interface DateFormatOptions {
  year?: "numeric";
  month?: "2-digit" | "numeric" | "narrow" | "short" | "long";
  day?: "numeric";
}

interface TimeFormatOptions {
  hour?: "2-digit" | "numeric";
  minute?: "2-digit" | "numeric";
  second?: "2-digit" | "numeric";
  hour12?: boolean;
}

const getFormatedDate = (isoDateString: any) => {
  // Convert ISO date string to Date object
  const dateObj = new Date(isoDateString);

  const optionsDate: DateFormatOptions = {
    year: "numeric",
    month: "short",
    day: "numeric",
  };
  const formattedDate = dateObj
    .toLocaleDateString("en-US", optionsDate)
    .toUpperCase();

  const optionsTime: TimeFormatOptions = {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  };
  const formattedTime = dateObj.toLocaleTimeString("en-US", optionsTime);

  const formattedDateTime = `${formattedDate}, ${formattedTime}`;
  return formattedDateTime;
};

export default getFormatedDate;
